import {
	IDataListColumn,
	IIndexEndpoint,
	PaginatedAutoDataList,
	laravelPaginatedListFetchConfig,
	useFormatDate,
} from "@dgs/core";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { getFullNameFromContactOption } from "../shared/select/ContactSelectField";
import { IClippingIndexResource } from "../shared/types";

interface Props {
	service: IIndexEndpoint<IClippingIndexResource>;
}

export const ArchivedEntityClippingList: FC<Props> = ({ service }) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const formatDate = useFormatDate();

	const columns: IDataListColumn<IClippingIndexResource>[] = useMemo(
		() => [
			{
				heading: t("Title"),
				type: "value",
				valueKey: "title",
			},
			{
				heading: t("Contact"),
				type: "value",
				valueKey: "contact",
				render: (clipping) => (clipping.contact ? getFullNameFromContactOption(clipping.contact) : ""),
			},
			{
				heading: t("Company"),
				type: "value",
				valueKey: "company.name",
			},
			{
				heading: t("Event"),
				type: "value",
				valueKey: "event.name",
			},
			{
				heading: t("Provider"),
				type: "value",
				valueKey: "provider",
			},
			{
				heading: t("Published at"),
				type: "value",
				valueKey: "publishedAt",
				render: (clipping) => formatDate(clipping.publishedAt),
			},
		],
		[t, formatDate],
	);

	return (
		<PaginatedAutoDataList
			name="archivedClippings"
			heading={t("Clippings")}
			empty={t("No clippings available.")}
			columns={columns}
			listFetchConfig={laravelPaginatedListFetchConfig(service.listKey, service.index)}
			initialSearch={{
				search: "",
				searchFields: [
					{ name: "title", label: t("Title") },
					{ name: "companies.name", label: t("Company name") },
					{ name: "contacts.firstName", label: t("Contact first name") },
					{ name: "contacts.lastName", label: t("Contacts last name") },
				],
			}}
			onRowClick={(clipping) => navigate(`/clippings/${clipping.id}`)}
		/>
	);
};
